import { render, staticRenderFns } from "./FormEmissioneVeicolo.vue?vue&type=template&id=1e58ca96&scoped=true"
import script from "./FormEmissioneVeicolo.vue?vue&type=script&lang=js"
export * from "./FormEmissioneVeicolo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e58ca96",
  null
  
)

export default component.exports